import { useMutation, useQueryClient } from '@tanstack/react-query';
import defaultCurrencyApi from '@/features/dashboard/paymentConfig/api/defaultCurrencyApi.ts';
import { defaultCurrencyApiQueryKeys } from '@/features/dashboard/paymentConfig/api/defaultCurrencyApi.queryKeys.ts';
import { DefaultCurrencyDto } from '@/features/dashboard/paymentConfig/types/DefaultCurrencyDto.ts';
import { toast } from 'sonner';

export default function useSetDefaultCurrency() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: DefaultCurrencyDto) => defaultCurrencyApi.set(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: defaultCurrencyApiQueryKeys.all(),
      });
      toast.success('Domyślna waluta została zapisana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas zapisywania domyślnej waluty.',
      });
    },
  });
}
